export default {
    baseStyle: {
        container: {
            borderWidth: 1,
            p: 16,
            width: 'full',
            gap: 12
        },
        icon: {
            flexShrink: 0,
            boxSize: 4
        },
        description: {
            lineHeight: 'short',
            textStyle: 'bodyLarge2'
        }
    },
    variants: {
        info: {
            container: {
                borderColor: 'white',
                backgroundColor: 'blue',
                color: 'white'
            },
            icon: {
                color: 'white',
                insideColor: 'blue'
            }
        },
        success: {
            container: {
                borderColor: 'green',
                backgroundColor: 'lightGreen',
                alignItems: 'center',
                borderRadius: 'none',
                color: 'fullBlack'
            },
            title: {
                fontSize: 'lg',
                fontWeight: 400,
                lineHeight: 'short',
                letterSpacing: '0.01em'
            },
            icon: {
                color: 'green'
            }
        },
        warning: {
            container: {
                borderColor: 'orange',
                backgroundColor: 'lightPink',
                color: 'fullBlack'
            },
            icon: {
                color: 'orange'
            }
        },
        error: {
            container: {
                borderColor: 'red',
                backgroundColor: 'lightPink',
                color: 'fullBlack'
            },
            icon: {
                color: 'red'
            }
        },
        cardInfos: {
            container: {
                padding: '16px',
                backgroundColor: 'lightBeige',
                borderColor: 'lightBeige'
            }
        },
        defaultProps: {
            variant: 'info'
        }
    }
}
